const webhookObjectType = {
  PixKey: 'PixKey',
  BcbPixCashIn: 'BcbPixCashIn',
  CashIn: 'CashIn',
  CashInRefund: 'CashInRefund',
  Transfer: 'Transfer',
  TransferRefund: 'TransferRefund',
  Validation: 'Validation',
  PaymentInitiation: 'PaymentInitiation',
  Account: 'Account'
};

module.exports = webhookObjectType;
